// extracted by mini-css-extract-plugin
export var active = "index-module--active--d1f2c";
export var arrow = "index-module--arrow--8c1f0";
export var language_list = "index-module--language_list--cbb24";
export var language_list_li = "index-module--language_list_li--fafa3";
export var language_list_link = "index-module--language_list_link--4e2fb";
export var language_list_ul = "index-module--language_list_ul--857e0";
export var wrapper = "index-module--wrapper--1fc7e";